export const LEAF_GRID =
  "grid items-center gap-x-2 gap-y-2 px-4 " +
  "grid-cols-[minmax(0,1fr)_168px_56px_56px_32px_64px] " +
  "[grid-template-areas:'leaf_leaf_leaf_leaf_leaf_leaf'_'label_type_req_ps_help_slot'] " +
  "min-[1400px]:gap-x-3 min-[1400px]:gap-y-0 " +
  "min-[1400px]:grid-cols-[minmax(0,1fr)_272px_204px_80px_80px_40px_72px] " +
  "min-[1400px]:[grid-template-areas:'leaf_label_type_req_ps_help_slot']";

export const AREA = {
  leaf: "[grid-area:leaf]",
  label: "[grid-area:label]",
  type: "[grid-area:type]",
  req: "[grid-area:req]",
  ps: "[grid-area:ps]",
  help: "[grid-area:help]",
  slot: "[grid-area:slot]",
};
